import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Cctv, Menu } from "lucide-react";
import { Sidebar } from "./Sidebar";
import { SidebarContent } from "./SidebarContent";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Toaster } from "@/components/ui/sonner";

export function AppShell() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="h-[100dvh] min-h-0 overflow-hidden bg-[#0b0b0d] text-white flex">
      <Sidebar />

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="md:hidden sticky top-0 z-40 h-14 border-b border-white/[0.06] bg-[#0f0f12]/95 backdrop-blur flex items-center justify-between px-3">
          <button
            onClick={() => setMobileOpen(true)}
            className="size-11 rounded-xl grid place-items-center text-zinc-300 hover:text-white hover:bg-white/[0.06] transition-colors"
            data-testid="mobile-menu-toggle"
            aria-label="Ouvrir le menu"
          >
            <Menu className="size-5" strokeWidth={1.7} />
          </button>

          <div className="flex items-center gap-2 text-sm font-semibold tracking-tight">
            <Cctv className="size-4 text-brand" strokeWidth={1.8} />
            <span>CAM</span>
          </div>

          <div className="size-11" aria-hidden="true" />
        </header>

        <main className="flex-1 min-w-0 overflow-auto overscroll-contain" data-testid="app-main">
          <Outlet />
        </main>
      </div>

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent
          side="left"
          className="p-0 w-[min(18rem,88vw)] bg-[#111114] border-white/[0.08] md:hidden"
          data-testid="mobile-sidebar"
        >
          <SheetTitle className="sr-only">Navigation CAM</SheetTitle>
          <SidebarContent onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>

      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}
